import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-sky border-b-2 border-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo - Links to home */}
          <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
            <img 
              src="/logo.png" 
              alt="BandCam.io Logo" 
              className="w-8 h-8 object-contain"
            />
            <span className="ml-2 text-xl font-bold text-black">BandCam.io</span>
          </Link>
          
          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link 
              to="/schools" 
              className="text-black hover:text-gray-700 transition-colors font-medium"
            >
              Find Your School
            </Link>
            <Link 
              to="/band-directors" 
              className="text-black hover:text-gray-700 transition-colors font-medium"
            >
              Band Directors
            </Link>
            <Link 
              to="/blog" 
              className="text-black hover:text-gray-700 transition-colors font-medium"
            >
              Blog
            </Link>
            <Link 
              to="/about" 
              className="text-black hover:text-gray-700 transition-colors font-medium"
            >
              About Us
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-black hover:text-gray-700 p-2"
            onClick={toggleMobileMenu}
            onTouchStart={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t-2 border-black">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/schools" 
                className="text-black hover:text-gray-700 transition-colors font-medium py-2"
                onClick={closeMobileMenu}
              >
                Find Your School
              </Link>
              <Link 
                to="/band-directors" 
                className="text-black hover:text-gray-700 transition-colors font-medium py-2"
                onClick={closeMobileMenu}
              >
                Band Directors
              </Link>
              <Link 
                to="/blog" 
                className="text-black hover:text-gray-700 transition-colors font-medium py-2"
                onClick={closeMobileMenu}
              >
                Blog
              </Link>
              <Link 
                to="/about" 
                className="text-black hover:text-gray-700 transition-colors font-medium py-2"
                onClick={closeMobileMenu}
              >
                About Us
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
